module.exports = __webpack_public_path__ + "static/media/boots_non_food.ae9a4493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/nonfood-store/boots_non_food.png
// module id = 486
// module chunks = 0